<template>
  <div>
    <common-dialog
      ref="dialog"
      width="850px"
      line-form
      show-save-button
      unit="设备"
      edit-title
      id-key="EquipmentId"
      :data="data"
      :before-save="onBeforeSave"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @closed="cancel"
      :form-rules="rules"
      :save-func="api.save"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="设备类别" prop="ClassId">
              <tree-select
                ref="TreeSelect"
                :props="props"
                :options="TreeData"
                :value="data.ClassId"
                :clearable="false"
                :accordion="true"
                :parentSelect="true"
                placeholder="请选择"
                @node-select="onTreeSelect($event)"
              />
              <!-- <el-select v-model="data.ClassId">
								<el-option :value="0" label="类别1"></el-option>
								<el-option :value="1" label="类别2"></el-option>
								<el-option :value="2" label="类别3"></el-option>
							</el-select> -->
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备编号" prop="EquipmentNo">
              <span v-if="Mode == 0" class="detail-span">{{
                data.EquipmentNo
              }}</span>
              <el-input
                v-else
                v-model="data.EquipmentNo"
                placeholder="请输入设备编号"
              ></el-input>
              <!-- <el-input type="text" v-model="data.EquipmentNo" placeholder="请输入设备编号"></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备名称" prop="EquipmentName">
              <el-input
                type="text"
                v-model="data.EquipmentName"
                placeholder="请输入设备名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="计量单位" prop="UnitName">
              <el-input
                type="text"
                v-model="data.UnitName"
                placeholder="请输入计量单位"
                @click.native="onUnitDialog"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="型号">
              <el-input
                type="text"
                v-model="data.Model"
                placeholder="请输入型号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="供应单位">
              <el-input
                type="text"
                v-model="data.Supplier"
                placeholder="请输入供应单位"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="维修商">
              <el-input
                type="text"
                v-model="data.Repairer"
                placeholder="请输入维修商"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="制造商">
              <el-input
                type="text"
                v-model="data.Manufacturer"
                placeholder="请输入制造商"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="原值">
              <el-input
                type="number"
                v-model="data.OriginalValue"
                placeholder="请输入原值"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="启用日期" prop="StartDate">
              <!-- <type-select ref="typeSelect" v-model="data.ClassId" /> -->
              <el-date-picker
                v-model="data.StartDate"
                value-format="yyyy-MM-dd"
                value="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="存放地点">
              <el-input
                type="text"
                v-model="data.StorageLocation"
                placeholder="请输入存放地点"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="取得方式">
              <el-input
                type="text"
                v-model="data.AcquireWay"
                placeholder="请输入取得方式"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备类型">
              <type-select ref="typeSelect" v-model="data.EquipmentTypeId" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="使用效率">
              <el-input
                type="number"
                v-model="data.Efficiency"
                placeholder="请输入使用效率"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="标准产出量">
              <el-input
                type="number"
                v-model="data.Workload"
                placeholder="请输入标准产出量"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="累计产出量">
              <div>{{ data.TotalOutput }}</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="状态">
              <el-select v-model="data.Status">
                <el-option :value="0" label="停用"></el-option>
                <el-option :value="1" label="待用"></el-option>
                <el-option :value="2" label="在用"></el-option>
                <el-option :value="3" label="维修"></el-option>
                <el-option :value="4" label="报废"></el-option>
                <el-option :value="5" label="出售"></el-option>
                <el-option :value="6" label="赠送"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="序号">
              <el-input type="number" v-int v-model="data.Sn"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="row-tb-head" style="margin-top: 10px">
          <span>工序列表</span>
          <div style="float: right">
            <el-button type="primary" @click="add">添加</el-button>
          </div>
        </div>
        <el-table
          title="工序列表"
          :data="Pus"
          row-key="ProcessId"
          border
          class="PubClass"
        >
          <el-table-column label="工序名称" min-width="110" align="center">
            <template slot-scope="{ row, $index }">
              <el-select
                v-model="row.ProcessId"
                @change="mouldChange($event, $index)"
              >
                <el-option
                  v-for="item in processList"
                  :key="item.ProcessId"
                  :value="item.ProcessId"
                  :label="item.ProcessName"
                />
              </el-select>
              <!-- <archive-select v-model="row.ProcessId" @active="mouldChange($event, $index)"></archive-select> -->
            </template>
          </el-table-column>
          <el-table-column label="工序编码" min-width="110" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.ProcessNo }}</span>
            </template>
          </el-table-column>
          <el-table-column label="生产阶段" min-width="110" align="center">
            <template slot-scope="{ row }">
              <span v-if="row.Stage == 1">注塑</span>
              <span v-if="row.Stage == 2">胶件加工 </span>
              <span v-if="row.Stage == 3">胶件加工</span>
              <span v-if="row.Stage == 4">产品装配</span>
              <span v-if="row.Stage == 5">产品组装</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" align="center" width="80">
            <template slot-scope="{ row, $index }">
              <el-button
                v-if="$permission.canWrite()"
                type="text"
                @click="del(row, $index)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <tableList 
          title="维保记录"
          :data="data.Maintenances"
          ref="repairList"
          :column="['PuNo', 'PuName']"
          :isDetail="true"  
        >
          <template slot="table">
            <el-table-column
              prop="MaintenanceDate"
              label="日期"
              min-width="110"
              :formatter="dateFormat"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="MaintenanceRemarks"
              label="维保内容"
              min-width="110"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="DpName"
              label="维保部门"
              min-width="110"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="MaintenanceUnit"
              label="维保单位"
              min-width="110"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="ReceiverEmpName"
              label="验收人"
              min-width="110"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="ReceiveDate"
              label="验收日期"
              min-width="110"
              align="center"
              :formatter="dateFormat"
            >
            </el-table-column>
          </template>
        </tableList>
        <tableList
          title="工作日志"
          :data="data.WorkRecords"
          ref="workList"
          :column="['PuNo', 'PuName']"
          :isDetail="true"
        >
          <template slot="table"> 
            <el-table-column
              prop="RecordTime"
              label="日期"
              min-width="110"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="RecordNo"
              label="工单号"
              min-width="110"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="StartTime"
              label="开始时间"
              min-width="110"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="EndTime"
              label="结束时间"
              min-width="110"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="WorkTime  "
              label="工时"
              min-width="110"
              align="center"
            >
            </el-table-column>
          </template>
        </tableList>
      </template>
    </common-dialog>
    <unit-dialog
      ref="unitDialog"
      in-dialog
      selectable
      @select="setUnit"
    ></unit-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import tableList from "../common/tableList";
import typeSelect from "@/components/facility/type/select";
import treeSelect from "@/components/common/treeSelect";
import unitDialog from "@/components/basedata/inventory/unit/listDialog";
import archiveSelect from "@/components/production/craftsmanship/archives/select";
import moment from "moment"
export default {
  mixins: [editDialogMixin],
  components: {  
    commonDialog,
    typeSelect,
    tableList,
    treeSelect,
    unitDialog,
    archiveSelect,
  },
  data() {
    return {
      Pus: [],
      TreeData: [],
      data: {
        EquipmentId: 0,
        EquipmentNo: "",
        EquipmentName: "",
        EquipmentTypeId: null,
        ClassId: null,
        UnitId: null,
        UnitName: "",
        Maintenances:[],
        WorkRecords:[],
        Model: "",
        Supplier: "",
        Repairer: "",
        Manufacturer: "",
        OriginalValue: null,
        StartDate: "",
        StorageLocation: "",
        AcquireWay: "",
        Efficiency: "",
        Workload: null,
        TotalWorkload: null,
        Sn: null,
        Status: null,
        Processes: [],
      },
      Mode: 1,
      code_api: require("@/api/sy/serialCode").default,
      props: {
        value: "ClassId",
        label: "ClassName",
        children: "children",
      },
      processList: [],
      processApi: require("@/api/production/teProcess").default,
      classApi: require("@/api/ba/class").default,
      api: require("@/api/ba/equipment").default,
      typeApi: require("@/api/ba/equipment").default,
      rules: {
        ClassId: [{ required: true, message: "设备类别不能为空" }],
        EquipmentNo: [{ required: true, message: "设备编号不能为空" }],
        EquipmentName: [{ required: true, message: "设备名称不能为空" }],
        UnitId: [{ required: true, message: "计量单位不能为空" }],
      },
    };
  },
  computed: {},
  methods: {
    dateFormat:function(row,column){
      var date = row[column.property];
      if(date == undefined || date ==''){
        return ''
      }
      return moment(date).format("YYYY-MM-DD")
    },
    onCreateOpened(data) {
      this.serialCode();  
      this.api.getMaxSn().then((res) => {
        this.data.Sn = res;
      });
      this.classApi.list({ ClassType: 9 }).then((res) => {
        this.TreeData = this.$commonJs.toTreeData(res.Data, "ClassId");
        this.$refs.TreeSelect.setData(data.ClassId);
      });
      this.processApi.list({}).then((res) => {
        this.processList = res.Data;
      });
    },
    onEditOpened(data) {
      this.api.info(data.EquipmentId).then((res) => {
        const ClassId = res.Data.ClassId;
        this.data = { ...res.Data, ClassId: null };
        this.classApi.list({ ClassType: 9 }).then((res) => {
          this.TreeData = this.$commonJs.toTreeData(res.Data, "ClassId");
          this.data.ClassId = ClassId;
          this.$refs.TreeSelect.setData(ClassId);
          this.Pus = this.data.Processes.map((i) => ((i.T = 3), i));
          this.processApi.list({}).then((res) => {
            this.processList = res.Data;
          });
        });
      });
    },
    onBeforeSave() {
      this.Pus = this.Pus.filter(i=>i.ProcessId != null)
      // console.log('this.Pus',this.Pus);
      
      if (this.data.Processes.length == 0) {
        this.data.Processes = this.Pus.map((item) => ((item.T = 0), item));
      } else {
        let delIds = this.Pus.map((item) => item.ProcessId);
        let delList = this.data.Processes.reduce((arr, item) => {
          if (!delIds.includes(item.ProcessId)) arr.push({ ...item, T: 2 });
          return arr;
        }, []);

        let addIds = this.data.Processes.map((item) => item.ProcessId);
        let addList = [];
        addList = this.Pus.reduce((arr, item) => {
          if (!addIds.includes(item.ProcessId)) arr.push({ ...item, T: 0 });
          return arr;
        }, []);
        let updateList = this.Pus.filter(i=>i.T == 1)
        console.log('updateList',updateList);
        this.data.Processes = [...addList, ...delList, ...updateList];
      }
    },
    onTreeSelect(t) {
      this.data.ClassName = !t ? "" : t.ClassName;
      this.data.ClassId = !t ? null : t.ClassId;
    },
    onUnitDialog() {
      this.$refs.unitDialog.open().then((that) => {
        that.getData();
      });
    },
    setUnit(t) {
      this.data.UnitId = t.UnitId;
      this.data.UnitName = t.UnitName;
    },
    cancel() {
      this.Pus = [];
      this.processList = [];
      // this.$refs.typeSelect.clear()
    },
    add() {
      this.Pus.push({
        ProcessId: null,
        ProcessName: "",
        ProcessNo: "",
        Stage: null,
      });
    },

    serialCode() {
      this.code_api.previewNo("设备").then((res) => {
        console.log("serialType", res);
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.EquipmentNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取设备编号失败");
        }
      });
    },

    mouldChange(e, index) {
      if (this.Pus[index].T == 3) this.Pus[index].T = 1;
      const ids = this.Pus.filter((i) => i.ProcessId === e);
      const is_report = ids.length >= 2 ? true : false;
      const data = this.processList.filter((i) => i.ProcessId === e)[0]
      if (is_report) this.$message.warning("列表中已存在相关工序");
      this.Pus[index].ProcessId = !is_report ? data.ProcessId : null;
      this.Pus[index].Stage = !is_report ? data.Stage : null;
      this.Pus[index].ProcessNo = !is_report ? data.ProcessNo : null;
    },
    del(row, index) {
      this.$confirm("确认删除该行数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.Pus.splice(index, 1);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .PubClass {
  .el-select .el-input__inner {
    border-top: none;
    border-left: none;
    border-right: none;
  }
}
</style>
